module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/pill-style4/pill-style4.component.scss
// module id = ./src/app/features/tabination/pill-style4/pill-style4.component.scss
// module chunks = main